module.exports = __webpack_public_path__ + "static/media/loading19.2d3a54f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/peaceSharkIndex/index/img/loading/loading19.png
// module id = 204
// module chunks = 0